import { MatDialog } from '@angular/material/dialog';
import { StaffService } from './../../../management360/staff/staff.service';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StaffSearchComponent } from '../../staff-search/staff-search.component';

@Injectable()
export class RequireStaffGuard implements CanActivate {

    // Constructor
    constructor(
        private staffService: StaffService,
        private dialog: MatDialog
    ) {}

    // Guard Functions
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (!this.staffService.selectedStaff) {
            const dialogBox = this.dialog.open(
                StaffSearchComponent,
                {
                    data: {
                        performRoute: true,
                        searchAndSelect: false
                    },
                    width: '100%',
                    height: '100%',
                    maxHeight: '100vh',
                    maxWidth: '100vw'
                }
            );
            return dialogBox.afterClosed().pipe(
                map(staff => {
                    if (staff) {
                        this.staffService.selectedStaff = staff;
                        return true;
                    } else {
                        return false;
                    }
                })
            );
        } else {
            return true;
        }
    }
}